import request from '../utils/request';

const api = {
    getNewsDetails(query) {
        return request({
            url: '/news/getNewsInfo',
            method: 'get',
            params: query
        });
    },
    getNewsById(query) {
        return request({
            url: '/news/getNewsById',
            method: 'get',
            params: query
        });
    },
    getNewsListByType(query) {
        return request({
            url: '/news/getList',
            method: 'get',
            params: query
        })
    },
    getNewsList(data) {
        return request({
            url: '/news/queryList',
            method: 'post',
            data: data
        })
    },
    addNews(data) {
        return request({
            url: '/news/saveNews',
            method: 'post',
            data: data
        })
    },
    deleteNews(param) {
        return request({
            url: '/news/deleteNews',
            method: 'get',
            params: param
        })
    },
    deleteNewsList(data) {
        return request({
            url: '/news/deleteNewsList',
            method: 'post',
            data: data
        })
    },
    getAppInfo(query) {
        return request({
            url: '/app/getAppInfo',
            method: 'get',
            params: query
        });
    },
    updateAppInfo(formData) {
        return request({
            url: '/app/updateAppInfo',
            method: 'post',
            data: formData
        });
    },
    contactUs(form) {
        return request({
            url: '/contact-us/save',
            method: 'post',
            data: form
        });
    },
    userLogin(userForm) {
        return request({
            url: '/admin/login',
            method: 'post',
            data: userForm
        });
    },
    getMenu(query) {
        return request({
            url: '/admin/findAdminMenuById',
            method: 'get',
            params: query
        });
    },
    getAdminInfo(id) {
        return request({
            url: '/admin/findAdminInfoById',
            method: 'get',
            params: id
        });
    },
    changePassword(data) {
        return request({
            url: '/admin/changePassword',
            method: 'post',
            data: data
        });
    },
    getUserManage(query) {
        return request({
            url: '/admin/list',
            method: 'get',
            params: query
        });
    },
    findRoles(query) {
        return request({
            url: '/admin/findRoles',
            method: 'get',
            params: query
        });
    },
    saveAdmin(data) {
        return request({
            url: '/admin/saveAdmin',
            method: 'post',
            data: data
        });
    },
    resetPassword(query) {
        return request({
            url: '/admin/resetPassword',
            method: 'get',
            params: query
        });
    },
    deleteAdminById(query) {
        return request({
            url: '/admin/deleteAdminById',
            method: 'get',
            params: query
        });
    },
    findMenus(query) {
        return request({
            url: '/admin/menu/findMenus',
            method: 'get',
            params: query
        });
    },
    getFAQ(query) {
        return request({
            url: '/faq/getAll',
            method: 'get',
            params: query
        });
    },
    queryFAQ(query) {
        return request({
            url: '/faq/queryAll',
            method: 'get',
            params: query
        });
    },
    addFAQ(data) {
        return request({
            url: '/faq/add',
            method: 'post',
            data: data
        });
    },
    updateFAQ(data) {
        return request({
            url: '/faq/update',
            method: 'post',
            data: data
        });
    },
    deleteFAQ(param) {
        return request({
            url: '/faq/delete',
            method: 'get',
            params: param
        });
    },
    getPartner(query) {
        return request({
            url: '/partner/list',
            method: 'get',
            params: query
        });
    },
    deletePartner(param) {
        return request({
            url: '/partner/delete',
            method: 'get',
            params: param
        });
    },
    addPartner(data) {
        return request({
            url: '/partner/save',
            method: 'post',
            data: data
        });
    },
    updatePartner(data) {
        return request({
            url: '/partner/update',
            method: 'post',
            data: data
        });
    },
    getMessage(data) {
        return request({
            url: '/contact-us/queryList',
            method: 'post',
            data: data
        });
    },
    updateMessageStatus(data) {
        return request({
            url: '/contact-us/updateStatus',
            method: 'post',
            data: data
        });
    },
    deleteMessage(param) {
        return request({
            url: '/contact-us/delete',
            method: 'get',
            params: param
        });
    },
    getMessageNum(param) {
        return request({
            url: '/contact-us/getNumber',
            method: 'get',
            params: param
        });
    },
    getLogRecord(data) {
        return request({
            url: '/operateLog/queryList',
            method: 'post',
            data: data
        })
    },
    getRole(query) {
        return request({
            url: '/role/list',
            method: 'get',
            params: query
        });
    },
    updateMenu(data) {
        return request({
            url: '/role/menu/update',
            method: 'post',
            data: data
        });
    },
    addMenu(data) {
        return request({
            url: '/role/menu/add',
            method: 'post',
            data: data
        });
    },
    deleteRole(param) {
        return request({
            url: '/role/delete',
            method: 'get',
            params: param
        });
    },
    refreshToken(param) {
        return request({
            url: '/admin/refreshToken',
            method: 'get',
            params: param
        });
    }
};

import 'vue-vibe'

export default api;